var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eoev-app-conditional-date"},[(_vm.currentSortField === 'moment' && _vm.showDate)?_c('span',{style:({ color: _vm.textColor })},[_vm._v(_vm._s(_vm.niceDate)+" —")]):(_vm.showLetter)?_c('span',{style:({ color: _vm.textColor })},[_vm._v(_vm._s(_vm.showLetter)+" —")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }